<template>
  <el-popover
    ref="popover"
    :key="key"
    v-model="visible"
    trigger="manual"
    placement="bottom-start"
    :disabled="disablePopover"
    append-to-body
  >
    <div v-if="!disablePopover" class="flow-chart-options">
      <div class="title">
        {{ t('eip.flow.taskApprovalDetails') }}
      </div>
      <!-- 已审批/待审批节点 -->
      <template v-if="hasOpinion">
        <table v-for="op in opinionData" :key="op.id">
          <tr>
            <td class="label">{{ t('eip.flow.taskName') }}</td>
            <td class="value">{{ t(op.taskName) }}</td>
          </tr>
          <tr v-if="op.auditor">
            <td class="label">{{ t('eip.flow.executor') }}</td>
            <td class="value">
              <el-popover
                :ref="`popover${op.userProfileKey}`"
                trigger="click"
                placement="right"
                popper-class="user-profile"
                :visible-arrow="false"
                :append-to-body="false"
                @hide="destroyProfile"
              >
                <span
                  slot="reference"
                  :class="{ processor: true, pointer: isProd }"
                  @click="showProfile(op, op.userProfileKey)"
                >
                  {{ op.auditorName }}
                  <template v-if="op.auditorAccount">
                    ({{ op.auditorAccount }})
                  </template>
                </span>
                <div :ref="op.userProfileKey" class="profile-target"></div>
              </el-popover>
            </td>
          </tr>
          <tr v-if="op.statusVal === '传阅'">
            <td class="label">{{ t('eip.flow.recipient') }}</td>
            <td class="value">
              <span v-for="user in op.qualfieds" :key="user.id">
                <el-popover
                  v-if="user.type === 'user'"
                  :ref="`popover${user.userProfileKey}`"
                  trigger="click"
                  placement="right"
                  popper-class="user-profile"
                  :visible-arrow="false"
                  @hide="destroyProfile"
                >
                  <span
                    slot="reference"
                    :class="{ processor: true, pointer: isProd }"
                    @click="showProfile(user, user.userProfileKey)"
                  >
                    {{ user.name }}

                    <template v-if="user.accounts || user.account">
                      ({{ user.accounts || user.account }})
                    </template>
                  </span>

                  <div :ref="user.userProfileKey" class="profile-target"></div>
                </el-popover>
                <el-tooltip
                  v-else
                  effect="light"
                  :content="getTipContent(user)"
                  placement="top"
                >
                  <el-button>
                    {{ user.name }}
                    <template v-if="user.account || user.accounts">
                      ({{ user.account || user.accounts }})
                    </template>
                  </el-button>
                </el-tooltip>
              </span>
            </td>
          </tr>
          <tr v-else>
            <td class="label">
              <span>{{ t('eip.flow.candidate') }}</span>
              <el-tooltip
                effect="light"
                :content="t('page.flowChart.tips')"
                placement="right"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </td>
            <td class="value">
              <span v-for="user in op.qualfieds" :key="user.id">
                <el-popover
                  v-if="user.type === 'user'"
                  :ref="`popover${user.userProfileKey}`"
                  trigger="click"
                  placement="right"
                  popper-class="user-profile"
                  :visible-arrow="false"
                  @hide="destroyProfile"
                >
                  <span
                    slot="reference"
                    :class="{ processor: true, pointer: isProd }"
                    @click="showProfile(user, user.userProfileKey)"
                  >
                    {{ user.name }}

                    <template v-if="user.accounts || user.account">
                      ({{ user.accounts || user.account }})
                    </template>
                  </span>

                  <div :ref="user.userProfileKey" class="profile-target"></div>
                </el-popover>
                <el-tooltip
                  v-else
                  effect="light"
                  :content="getTipContent(user)"
                  placement="top"
                >
                  <el-button>
                    {{ user.name }}
                    <template v-if="user.account || user.accounts">
                      ({{ user.account || user.accounts }})
                    </template>
                  </el-button>
                </el-tooltip>
              </span>
            </td>
          </tr>
          <tr>
            <td class="label">{{ t('eip.flow.startTime') }}</td>
            <td class="value">
              {{ op.createTime | timezoneDateFormat }}
            </td>
          </tr>
          <tr>
            <td class="label">{{ t('eip.flow.endTime') }}</td>
            <td class="value">
              {{ op.completeTime | timezoneDateFormat }}
            </td>
          </tr>
          <tr>
            <td class="label">{{ t('eip.flow.calcDuration') }}</td>
            <td class="value">{{ op.durMs | calcDuration }}</td>
          </tr>
          <tr>
            <td class="label">{{ t('eip.common.status') }}</td>
            <td class="value">{{ op.statusVal }}</td>
          </tr>
          <tr>
            <td class="label">{{ t('eip.common.opinion') }}</td>
            <td class="opinion">{{ op.opinion }}</td>
          </tr>
        </table>
      </template>

      <!-- 未审批节点 -->
      <template v-else>
        <div class="sub-title">
          {{ t('eip.flow.nodeSettingsDetails') }}
        </div>
        <table>
          <tr>
            <td class="label">{{ t('eip.common.status') }}</td>
            <td class="value">
              {{ t('eip.flow.noTasksHaveBeenGenerated') }}
            </td>
          </tr>
          <tr>
            <td class="label">
              <span>{{ t('eip.flow.tentativeCandidate') }}</span>
              <el-tooltip
                effect="light"
                :content="t('page.flowChart.tips2')"
                placement="right"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </td>
            <td class="value">
              <span v-for="user in opinionData" :key="user.id">
                <el-popover
                  v-if="user.type === 'user'"
                  :ref="`popover${user.userProfileKey}`"
                  append-to-body
                  trigger="click"
                  placement="right"
                  popper-class="user-profile"
                  :popper-options="{
                    boundariesElement: 'viewport',
                  }"
                  :visible-arrow="false"
                  @hide="destroyProfile"
                >
                  <span
                    slot="reference"
                    :class="{ processor: true, pointer: isProd }"
                    @click="showProfile(user, user.userProfileKey)"
                  >
                    {{ user.name }}

                    <template v-if="user.account || user.accounts">
                      ({{ user.account || user.accounts }})
                    </template>
                  </span>
                  <div :ref="user.userProfileKey" class="profile-target"></div>
                </el-popover>

                <el-tooltip
                  v-else
                  effect="light"
                  :content="getTipContent(user)"
                  placement="top"
                >
                  <el-button>
                    {{ user.name }}
                    <template v-if="user.account || user.accounts">
                      ({{ user.account || user.accounts }})
                    </template>
                  </el-button>
                </el-tooltip>
              </span>
            </td>
          </tr>
        </table>
      </template>
    </div>

    <div
      slot="reference"
      class="approver"
      :class="{ active: hasOpinion, 'predict-node': predict }"
      @click.stop="handleClick"
    >
      <el-tooltip
        placement="top"
        :disabled="!computedStyle.text"
        :content="t(computedStyle.text)"
      >
        <div
          :class="['wrapper', reference.class, shrinkAvatar ? 'shrink' : '']"
          :style="nodeStyle"
        >
          <img
            v-for="img in reference.images"
            :src="img"
            :class="{ pointer: !disablePopover }"
          />
        </div>
      </el-tooltip>
      <img
        v-if="nodeType"
        class="node-type"
        :style="taskStyle"
        :src="nodeType"
      />
      <el-tooltip :content="label" :disabled="disableLabelTip">
        <div ref="labelRef" class="label" :style="labelStyle">
          {{ label }}
        </div>
      </el-tooltip>

      <i
        v-if="hasOpinion"
        :class="[computedStyle.icon, 'status-icon']"
        :style="{ ...computedStyle.style, ...tipStyle }"
      />
    </div>
  </el-popover>
</template>

<script>
  import { APPROVER_TYPE } from './const'

  import { t } from '@/init'
  import { getAccountById } from '@/api/user'
  import {
    showUserProfile,
    destroyPreviousProfile,
  } from '@transsion/hotent-ui/src/util/showUserProfile'
  import { Illustration } from '../const'
  import { generateKey } from '../utils/index.js'

  import getNodeMixin from '../mixins/getNode'

  import HtAdminSvg from '../svg/HtadminImage.svg'
  import EmptySvg from '../svg/PlaceholderImage.svg'
  import OtherApproverSvg from '../svg/OtherApprover.svg'
  import { on, off } from 'element-ui/src/utils/dom'

  export default {
    name: 'Approver',
    filters: {
      calcDuration(ts) {
        let duration = '',
          st = 1000,
          mt = 60 * st,
          ht = 60 * mt,
          dt = 24 * ht,
          days = Math.floor(ts / dt),
          hours = Math.floor((ts % dt) / ht),
          mins = Math.floor((ts % ht) / mt),
          secs = Math.floor((ts % mt) / st)
        if (days > 0) duration += days + t('eip.common.day')
        if (hours > 0) duration += hours + t('eip.common.hour')
        if (mins > 0) duration += mins + t('eip.common.minute')
        if (secs > 0) duration += secs + t('eip.common.second')
        return duration
      },
    },
    mixins: [getNodeMixin],
    data() {
      return {
        visible: false,
        isProd: sessionStorage.getItem('env') === 'prod',
        shrinkAvatar: false,
        updated: false,
        disableLabelTip: true,
      }
    },
    computed: {
      disablePopover() {
        return !this.opinion && !this.allOpinion
      },
      reference() {
        // 超过4张只显示前4张
        const images = this.generateApprover(this.opinion)

        const length = images.length > 4 ? 4 : images.length

        return {
          images: images.slice(0, 4),
          class: 'length-' + length,
        }
      },
      opinion() {
        return this.data?.opinion
      },
      allOpinion() {
        return this.data?.allOpinions
      },
      opinionData() {
        // 对于审批详情，使用原始的allOpinions数据，而不是过滤后的opinion数据
        const data = this.allOpinion?.data || this.opinion?.data

        if (data && this.isProd) {
          this.generateUserProfileKey(data)
        }

        return data || []
      },
      hasOpinion() {
        return this.opinion?.hasOpinion
      },
      computedStyle() {
        // 包含有样式的状态
        const style_status = [
          'reject',
          'oppose',
          'backToStart',
          'signNotPass',
          'manual_end',
          'awaiting_check',
          'hangUp',
          'revoker',
          'revoker_to_start',
          'agree',
          'signPass',
          'start',
          'reSubmit',
          'skip',
        ]
        const hasStyleData = this.opinionData.filter((item) =>
          style_status.includes(item.status)
        )

        const firstData = hasStyleData?.[0] || []

        if (!firstData) {
          return {
            icon: '',
            style: {},
          }
        }

        const target = Illustration.find((item) =>
          item.status.includes(firstData.status)
        )

        if (!target) {
          return {
            icon: '',
            style: {},
          }
        }

        const findIndex = target.status.findIndex(
          (item) => item === firstData.status
        )

        target.text = target.list[findIndex]

        return target
      },
      nodeType() {
        const loopCharacteristics = this.data?.loopCharacteristics

        const type = loopCharacteristics
          ? loopCharacteristics?.isSequential
            ? 'serial'
            : 'parallel'
          : 'normal'

        return APPROVER_TYPE[type]
      },
    },
    mounted() {
      const graph = this.getGraph()
      graph.on('node:click', () => {
        this.$refs.popover.showPopper = false
        this.destroyProfile()
      })

      this.$nextTick(() => {
        if (this.$refs.labelRef) {
          this.disableLabelTip = this.$refs.labelRef.offsetWidth < 140
        }
      })
    },
    methods: {
      handleClick() {
        this.visible = !this.visible

        const handler = () => {
          this.visible = false
        }

        if (this.visible) {
          on(document, 'click', handler)
        } else {
          off(document, 'click', handler)
        }
      },
      async showProfile(userInfo, refName) {
        if (!this.isProd) {
          console.warn('飞书社交卡片只在生产环境生效！')
          return
        }
        // 关闭上一个弹窗
        this.destroyProfile()

        // 解决popover嵌套的情况下，点击空白区域，无法关闭当前popover
        let event = window.event || arguments.callee.caller.arguments[0]
        event.stopPropagation()

        // 姓名
        let name = userInfo.name || userInfo.auditorName

        // 用户id
        let userId = userInfo.type ? userInfo.id : userInfo.auditor

        let account =
          userInfo.account || userInfo.auditorAccount || userInfo.accounts || ''

        if (account.split(',').length > 1) {
          account = ''
        }

        // 需要显示到的位置
        let targetEl = Array.isArray(this.$refs[refName])
          ? this.$refs[refName][0]
          : this.$refs[refName]

        // 弹出框
        let popover = Array.isArray(this.$refs['popover' + refName])
          ? this.$refs['popover' + refName][0]
          : this.$refs['popover' + refName]

        if (!name || name === 'htadmin' || !targetEl) {
          if (name === 'htadmin') {
            console.warn('无法获取htadmin的信息')
          }
          this.closePopover(popover)

          return
        }

        if (!account) {
          const user = await getAccountById(name, userId)
          if (!user.length) {
            this.$message.error(this.t('page.flowChart.feishuError'))
            this.closePopover(popover)
            return
          }
          account = user[0].account
        }

        this.userProfile = await showUserProfile({
          code: account,
          type: 'account',
          targetEl,
          cb: (code, msg) => {
            if (code === 'error') {
              console.log(msg)
              this.closePopover(popover)
            }
          },
        })

        // 重新计算位置
        popover && popover.updatePopper()
      },
      // 手动关闭popover
      closePopover(popover) {
        console.warn('无法获取该人员信息，请联系开发人员！')
        this.$nextTick(() => {
          popover && (popover.showPopper = false)
          this.$forceUpdate()
        })
      },
      destroyProfile: destroyPreviousProfile,
      getTipContent(user) {
        let content = user.users

        if (user.account || user.accounts) {
          content += `(${user.account || user.accounts})`
        }

        return content
      },
      generateUserProfileKey(data) {
        Array.isArray(data) &&
          data.forEach((item) => {
            if (!item.userProfileKey) {
              this.$set(item, 'userProfileKey', generateKey(item))
            }

            if (Array.isArray(item.qualfieds)) {
              this.generateUserProfileKey(item.qualfieds)
            }
          })
      },
      generateApprover(opinion) {
        if (!opinion) {
          return [EmptySvg]
        }
        const approverImage = []
        const { hasOpinion, data } = opinion || {}

        if (Array.isArray(data)) {
          data.forEach((item) => {
            if (!hasOpinion) {
              // 不存在审批意见，取待审批人信息
              const { type, accounts } = item

              if (type === 'user') {
                accounts && approverImage.push(generateUrl(accounts))
              } else {
                approverImage.push(OtherApproverSvg)
              }
            } else {
              // 存在审批意见，取审批人信息
              const { status, qualfieds, auditorAccount } = item

              auditorAccount && approverImage.push(generateUrl(auditorAccount))

              Array.isArray(qualfieds) &&
                qualfieds.forEach((approver) => {
                  if (approver.type === 'user') {
                    approver.account &&
                      approverImage.push(generateUrl(approver.account))
                  } else {
                    approverImage.push(OtherApproverSvg)
                  }
                })
            }
          })
        }

        if (!approverImage.length) {
          approverImage.push(EmptySvg)
        }
        const list = Array.from(new Set(approverImage))

        if (list.length === 1) {
          // 这几个头像缩小
          this.shrinkAvatar = [EmptySvg, OtherApproverSvg, HtAdminSvg].includes(
            list[0]
          )

          // 缩小的头像需要重新计算位置， 但是挂载后只执行一次，不然组件重新渲染会再次计算位置，导致位置错误
          if (this.shrinkAvatar) {
            const node = this.getNode()

            const { x, y } = node.position()

            !this.updated &&
              this.$nextTick(() => {
                this.updated = true
                node.resize(50, 50)
                node.position(x + 5, y + 5)
              })
          }
        }

        return list

        function generateUrl(account) {
          if (account === 'htadmin') return HtAdminSvg

          if (account.length !== 8) return EmptySvg

          return `https://pfresource.transsion.com:19997/${account.slice(
            0,
            4
          )}/${account.slice(4)}/H_${account}_D.png`
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .approver {
    width: 60px;
    height: 60px;
    opacity: 0.3;
    &.active {
      color: #161616;
      opacity: 1;

      & > .wrapper {
        &.length-1 {
          img {
            width: 56px;
            height: 56px;
            border: 2px solid #5465ff !important;
          }

          &.shrink {
            img {
              width: 48px;
              height: 48px;
              border: 2px solid #5465ff !important;
            }
          }
        }
      }
    }

    &.predict-node {
      opacity: 0.6;

      img {
        border-color: #9d4dff;
      }
    }

    & > .node-type {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 30%);
    }

    & > .wrapper {
      img {
        position: absolute;
        top: 50%;
        border: 2px solid #fff;
        border-radius: 50%;
        transform: translateY(-50%);
        &.pointer {
          cursor: pointer;
        }
      }

      $lengthArr: 1, 2, 3, 4;
      $widthArr: 60px, 48px, 41px, 31px;
      $diff: 0px, 8px, 7.5px, 8.3px;
      $border: 0px, 2px, 2px, 2px;
      @each $length in $lengthArr {
        $index: index($lengthArr, $length);
        $pixel: nth($widthArr, $index);
        $borderPixel: nth($border, $index);
        &.length-#{$length} {
          img {
            width: $pixel;
            height: $pixel;
            border: $borderPixel solid #fff;
          }
        }

        @for $n from 1 through $length {
          $diffPixel: nth($diff, $index);
          &.length-#{$length} {
            img:nth-child(#{$n}) {
              left: calc(#{$n - 1} * #{$diffPixel});
            }
          }
        }
      }

      &.length-1.shrink {
        img {
          width: 50px;
          height: 50px;
        }
      }
    }

    & > .label {
      position: absolute;
      top: calc(100% + 8px);
      left: 50%;
      max-width: calc(100% + 80px);
      overflow: hidden;
      font-size: 12px;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      transform: translateX(-50%);
    }

    .status-icon {
      position: absolute;
      top: -10%;
      right: 10%;
      z-index: 1;
      flex: none;
      clip-path: circle(8px at 51% 46%);
      font-size: 18px;
      background-color: #fff;
      opacity: 1;
    }
  }

  .flow-chart-options {
    max-height: 420px;
    overflow-y: auto;

    .title {
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
    }

    .sub-title {
      font-size: 12px;
    }

    table {
      margin-bottom: 10px;
      font-size: 12px;
      border-spacing: 0;
      border-bottom: 1px solid #e7eaec;
      border-left: 1px solid #e7eaec;
      td {
        padding: 8px;
        line-height: 1.42857;
        vertical-align: middle;
        border-top: 1px solid #e7eaec;
        border-right: 1px solid #e7eaec;
      }
      .label {
        width: 80px;
        font-weight: bold;
      }
      .value {
        width: 160px;

        .processor {
          color: #0560fd;

          &.pointer {
            cursor: pointer;
          }
        }

        & > span {
          &::after {
            content: ',';
          }

          &:last-child {
            &::after {
              content: '';
            }
          }
        }
      }
      .opinion {
        min-width: 250px;
        max-width: 250px;
        word-wrap: break-word;
      }
    }
  }
</style>
